<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {Link, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";

export default {
  components: {Link, Card},
  mixins: [FormElements, Changes],
  data() {
    return {
      messageId: '',
      tags: [],

      form: useForm({
        name: '',
        description: '',
        tag_ids: []
      })
    }
  },
  methods: {
    setMessage(message) {
      this.messageId = message.id;
      let tags = message.tags ?? {};

      this.tags = tags.map(tag => {
        return {
          value: tag.id,
          label: tag.name,
        }
      });

      this.form.defaults({
        name: message.name,
        description: message.description,
        tag_ids: tags.map(tag => tag.id) ?? [],
      });
      this.form.reset();
      this.form.isDirty = false;
    },
  }
}
</script>

<template>
  <div class="row g-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Details</h2>

        <Input
            v-model="form.name"
            :form="form"
            name="name"
            label="Titel"
            required
        />

        <Textarea
            v-model="form.description"
            :form="form"
            type="textarea"
            name="description"
            label="Bericht"
        />

        <Select
            v-memo="[tags]"
            v-model="form.tag_ids"
            name="tag_ids"
            label="Labels"
            :form="form"
            :multiple="true"
            :options="tags"
            :ajaxUrl="route('api.v1.knowledge_base.tags.list')"
        />

      </Card>
    </div>
  </div>

  <div class="row g-4 mt-4">
    <div class="col-xl-12">
        <slot name="widgets" />
    </div>
  </div>

</template>